export const patreonUrl = "https://www.patreon.com/fantasy_football/membership";
export const tgLink = "https://t.me/+r7cW6SfXBpJlYjIy";

export const primaryBlue = "#5d03b1";
export const primaryRed = "#101469";
export const primaryRedTransparent = "rgba(16, 24, 47, 0.7)";
export const gray = "gray";
export const green = "#4edd54";
export const red = "#f44336";
export const yellow = "rgb(255 222 1)";

export const teamColors = {
  ATM: ["rgb(185,38,53)", "#fff"],
  BAY: ["rgb(186,41,27)", "rgb(87,128,208)"],
  PSG: ["rgb(14,31,67)", "rgb(136,34,43)"],
  ARS: ["#fff", "rgb(198,55,57)"],
  NAP: ["#fff", "rgb(58,136,193)"],
  VIL: ["rgb(230,213,109)", "rgb(37,56,79)"],
  DOR: ["rgb(242,213,82)", "rgb(32,30,19)"],
  LIV: ["rgb(165,35,56)", "rgb(165,35,56)"],
  SCP: ["#fff", "rgb(58,131,87)"],
  SLA: ["#fff", "rgb(203,53,66)"],
  LAS: ["#fff", "#000"],
  RMA: ["#fff", "rgb(89,101,134	)"],
  BAR: ["rgb(158,47,69)", "rgb(31,45,94)"],
  GAL: ["rgb(124,30,50)", "rgb(232,152,60)"],
  MCI: ["rgb(137,182,223)", "rgb(51,75,102)"],
  INT: ["rgb(19,20,37)", "rgb(47,103,198)"],
  PSV: ["rgb(218,91,85)", "#fff"],
  BRU: ["rgb(83,153,216)", "rgb(23,22,24)"],
  BOD: ["rgb(242,216,73)", "rgb(14,15,13)"],
  AEK: ["rgb(32,30,19)", "rgb(242,213,82)"],
  AST: ["rgb(149,28,54)", "rgb(74,115,183)"],
  COM: ["#fff", "rgb(28,49,91)"],
  FEN: ["rgb(255,221,0)", "rgb(0,76,153)"],
  FEY: ["#fff", "rgb(226,0,26)"],
  LEI: ["rgb(0,43,92)", "rgb(255,205,0)"],
  LEN: ["rgb(255,215,0)", "rgb(220,0,0)"],
  LIL: ["rgb(35,45,95)", "rgb(237,29,36)"],
  MUN: ["#fff", "rgb(218,41,28)"],
  POR: ["#fff", "rgb(0,91,170)"],
  BET: ["#fff", "rgb(0,120,70)"],
  ROM: ["rgb(218,41,28)", "rgb(255,205,0)"],
  SLO: ["#fff", "rgb(38,92,170)"],
  SAB: ["#fff", "rgb(0,82,155)"],
  SHA: ["rgb(255,102,0)", "#000"],
  STU: ["#fff", "rgb(229,0,0)"],
  VIK: ["#fff", "rgb(15,29,46)"],
};
